module.exports = __webpack_public_path__ + "img/bonus_phone_zh.5862cbac.png";